import React, { Component } from "react"
import TableNotasFiscais from "./TableNotasFiscais"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
import Moment from "moment"

export default class NotasFiscais extends Component {
  constructor() {
    super()
    this.getNotas = this.getNotas.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { notas: [], initialNotas: [], showTable: false }
  }
  componentWillMount() {
    this.getNotas()
  }
  getNotas() {
    var contratoID = this.props.match.params.id
    ApiHelper.getNotasForContrato(contratoID, (notas, error) => {
      if (notas) {
        this.setState({ notas: notas, initialNotas: notas, showTable: true })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didDelete() {
    this.getNotas()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialNotas.filter(nota => {
      return (
        nota.numero.toLowerCase().search(searchText) !== -1 ||
        Moment(nota.data)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        nota.contrato.objeto.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      notas: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Contratos">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableNotasFiscais
            contratoID={this.props.match.params.id}
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Notas fiscais"
            subtitle={
              "Listagem de todas as notas fiscais do contrato Nº: " +
              (this.state.notas[0]
                ? this.state.notas[0].contrato.num_contrato
                : "")
            }
            backgroundColor="as-blue"
            rows={this.state.notas}
          />
        ) : (
            <Loading />
          )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/baixas/NotasFiscais.js